import { PortalSettings } from '../models';
import { useDocument } from './useDocument';

export function usePortalSettings() {
  return useDocument<PortalSettings>('PortalSettings', 'portal_settings');
}
